// Dependencies
import React from 'react';

// Material
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Services
import { loggerService } from 'services/logger';

// Global Components
import { BreadcrumbCommon } from 'components/BreadcrumbCommon';

function UnAuthorized() {
	loggerService.trackPageView('UnAuthorized', '/UnAuthorized');

	loggerService.trackTrace('********** UnAuthorized Rendering *****************');

	return (
		<>
			<Box mb={2}>
				<BreadcrumbCommon />
			</Box>

			<Box
				sx={{ width: 'auto' }}
			>
				<Typography component="h2" variant="h6" color="primary" gutterBottom>
					UnAuthorized
				</Typography>
				<Typography>
					Contact the Application Data Steward to request access.
				</Typography>
			</Box>
		</>
	);
}

export default UnAuthorized;
